//@flow
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import ThumbnailUtil from '../util/ThumbnailUtil';
import { findDOMNode } from 'react-dom';
import screenfull from 'screenfull';
import $ from 'jquery';
import DrawingCanvas from './DrawingCanvas';
import PreviewHelper from '../helper/PreviewHelper';
import AnnotationUtil from '../queries/annotations/AnnotationUtil';
import DrawingUtil from '../queries/drawings/DrawingUtil';
import CommentUtil from '../util/CommentUtil';
import { CommentFilterOption, KeyCode, Visibility } from '../util/Constants';
import FileInfoUtil from '../util/FileInfoUtil';
import { Div } from '../common/elements';
import WavePlayer from '../video/WavePlayer';
import Store from '../store/Store';
import {
  ACTIVE_COMMENT_ID,
  AI_METADATA,
  ASSET_PREVIEW_INFO,
  PERMISSIONS,
  PREVENT_MEDIA_AUTOPLAY,
  SHOW_COMMENTS,
  SHOW_METADATA_TIMELINE,
  SYNC_VIDEOS,
  VIDEO_CONTROLLER,
  VIDEO_DURATION,
  VIDEO_FRAME_RATE,
  Comment
} from '../store/Constants';
import AudioPlayer from '../audio/AudioPlayer';
import WithVideoComments from '../comments/WithVideoComments';
import StoreListener from '../store/StoreListener';
import { AnnotationThread } from '../autogenerated/ZoomBridge';
import VideoController, { VideoControllerState } from '../video/VideoController';
import VideoControls from '../video/VideoControls';
import { toggleFullscreenClass } from '../util/DOMUtil';
import type { ClipConfig } from '../hoc/Clip';
import FetchJsonJob from '../protocol/FetchJsonJob';
import { getFilteredComments } from '../store/StoreUtil';
import ViewUtil from '../ViewUtil';
import { playbackRateOptions, toMSS, smpteToMillis } from '../util/VideoUtil';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import MetadataTimeline from '../video/MetadataTimeline';
import { isMobile } from '../util/ScreenUtil';

import './AssetVideoPreview.css';
import MetadataTimelineHeader, { MetadataTimelineSeekChangeEvents } from '../video/MetadataTimelineHeader';
import Spinner from '../common/Spinner';
import t from '../i18n/I18n';
import Storage from '../protocol/Storage';
import withUniResizableColumn from '../hoc/withUniReziableColumn';

const debug = require('../debug/debug')('wc:video:AssetVideoPreview');

const _store = {
  src: null,
  currentTime: null,
  volume: 70,
  muted: false,
  frameRate: 0
};

const storeItems = [SHOW_COMMENTS, SYNC_VIDEOS, PERMISSIONS, SHOW_METADATA_TIMELINE, AI_METADATA];

const getVideoNode = (component) => component._videoRef;
//$FlowFixMe
@StoreListener(storeItems)
//$FlowFixMe
@WithVideoComments(getVideoNode)
//$FlowFixMe
@withUniResizableColumn
export default class AssetVideoPreview extends React.Component {
  static propTypes = {
    selectedAsset: PropTypes.object.isRequired,
    comments: PropTypes.array,
    commentFilter: PropTypes.string,
    allowFullscreen: PropTypes.bool,
    onFullScreenToggle: PropTypes.func,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onSeekChange: PropTypes.func,
    onQualityChange: PropTypes.func,
    onSpeedChange: PropTypes.func,
    onVolumeChange: PropTypes.func,
    onMute: PropTypes.func,
    onCommentButtonClick: PropTypes.func,
    onGotoPrevComment: PropTypes.func,
    onGotoNextComment: PropTypes.func,
    onProgress: PropTypes.func,
    quality: PropTypes.any,
    blockKeyEvents: PropTypes.bool,
    onClickThroughShape: PropTypes.func,
    enableComments: PropTypes.bool,
    addingShape: PropTypes.object,
    onShapeCreated: PropTypes.func,
    onShapeDeleted: PropTypes.func,
    onShapeDrag: PropTypes.func,
    onShapeDragEnd: PropTypes.func,
    isExpandedMode: PropTypes.bool,
    getFullScreenNode: PropTypes.func,
    onFullScreenChange: PropTypes.func,
    addMouseListener: PropTypes.func,
    removeMouseListener: PropTypes.func,
    fullscreenControlsOffset: PropTypes.number,
    style: PropTypes.object,
    waveplayer: PropTypes.bool,
    clipConfig: PropTypes.object,
    renderAudioComment: PropTypes.func,
    SHOW_COMMENTS: PropTypes.bool,
    SHOW_METADATA_TIMELINE: PropTypes.bool,
    SYNC_VIDEOS: PropTypes.bool,
    PERMISSIONS: PropTypes.object,
    AI_METADATA: PropTypes.object,
    renderWaveplayerComment: PropTypes.func,
    renderDownloadButton: PropTypes.func,
    assetKeyframeMetadata: PropTypes.array,
    isCompareMode: PropTypes.bool,
    setAssetKeyframeAiData: PropTypes.func,
    setOnLocateNodeSelection: PropTypes.func,
    setDeleteTimelineRow: PropTypes.func,
    onDataTimeLineClick: PropTypes.func
  };

  static contextTypes = {
    getTopBarVisibility: PropTypes.func,
    setTopBarVisibility: PropTypes.func
  };

  static defaultProps = {
    allowFullscreen: true,
    commentFilter: CommentFilterOption.ALL,
    onSeekChange: $.noop,
    onQualityChange: $.noop,
    onSpeedChange: $.noop,
    onVolumeChange: $.noop,
    onMute: $.noop,
    blockKeyEvents: false,
    enableComments: false,
    isExpandedMode: false,
    onFullScreenChange: $.noop,
    addMouseListener: $.noop,
    removeMouseListener: $.noop,
    fullscreenControlsOffset: 0,
    style: {},
    renderAudioComment: $.noop,
    clipConfig: {},
    renderDownloadButton: $.noop,
    PERMISSIONS: {}
  };

  _sharedController: VideoController;
  _privateController: ?VideoController;
  _audioPlayer: AudioPlayer;
  _canChangePlayState: boolean;
  _setCurrentTimeDebounceSettings: ?Object;
  _loadInfoJob: ?FetchJsonJob;
  _didAudioMouseDown: boolean;
  _isSeekingAudio: boolean;
  _metadataTimelineSeekChangeEnvets: MetadataTimelineSeekChangeEvents;
  _seekStartX: number;
  _playAfterSeek: boolean;
  videoStartTimeCodeMetadata: ?number;

  constructor(props) {
    super(props);
    this.state = {
      selectedAsset: this.props.selectedAsset,
      videoSrc: ThumbnailUtil.createVideoPreviewUrl(this.props.selectedAsset),
      qualityOptions: [],
      videoPreviewResolutionX: 0,
      videoPreviewResolutionY: 0,
      dataReady: false,
      isVideoUnavailable: false,
      bufferProgress: 0,
      clipRangeValue: null,
      isFullscreen: false,
      commentMarkersArray: [],
      videoFrameRate: 0,
      count: 0,
      subtitles: [],
      subtitleOptions: [],
      subtitle: null,
      audioTracks: [],
      audioTrackOptions: [],
      activeAudioTrackIndex: 0,
      didWaveformLoad: null,
      autoPlay: !Store.get(PREVENT_MEDIA_AUTOPLAY),
      currentScale: 1,
      isRecording: false,
      isMediaLoading: false
    };
    this._metadataTimelineSeekChangeEnvets = new MetadataTimelineSeekChangeEventsImpl(this);
    this._sharedController = Store.get(VIDEO_CONTROLLER);
    this._privateController = null;
    this._audioPlayer = null;
    this._canChangePlayState = true;
    this._playAfterSeek = false;

    this.loadAssetInfo();

    this.onClickFullscreen = this.onClickFullscreen.bind(this);
    this.onProgress = this.onProgress.bind(this);
    this.onDuration = this.onDuration.bind(this);
    this.onError = this.onError.bind(this);
    this.onFullscreenToggle = this.onFullscreenToggle.bind(this);
    this.onVolume = this.onVolume.bind(this);
    this.onMuted = this.onMuted.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.getVideoThumbnail = this.getVideoThumbnail.bind(this);
    this.renderScreenToggleButton = this.renderScreenToggleButton.bind(this);

    this.controller.addListener('change', this.onControllerChange);

    if (this.isAudio()) {
      this.state.didWaveformLoad = false;
      this.fetchWaveform();
    }

    setTimeout(() => {
      this.setVolume();
    }, 50);
    this.videoStartTimeCodeMetadata = undefined;
  }

  componentDidMount() {
    if (screenfull.on) {
      screenfull.on('change', this.onFullscreenToggle);
    }
    this.controller.playbackRate = 1;
    this.addKeyListeners();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.waveplayer) {
      return;
    }

    if (this.state.isFullscreen !== prevState.isFullscreen) {
      if (this.state.isFullscreen) {
        debug('[componentDidUpdate()] entering fullscreen mode');
      } else {
        debug('[componentDidUpdate()] leaving fullscreen mode');
        $(this.refs.videoContainer)
          .off('mousemove')
          .off('mouseleave');
      }
    }

    if (prevState.subtitle !== this.state.subtitle) {
      debug('[componentDidUpdate()] updating text tracks');
      this.updateTextTracks();
    }

    if (prevState.activeAudioTrackIndex !== this.state.activeAudioTrackIndex) {
      debug('[componentDidUpdate()] updating audio tracks');
      this.updateAudioTracks();
    }

    const clipConfig: ClipConfig = this.props.clipConfig;
    const { clipMode, clipStart, clipEnd } = clipConfig;
    if (!prevProps.clipConfig.clipMode && clipMode) {
      debug('[componentDidUpdate()] entering clip mode');
      this.removeKeyListeners();
      if (this.controller.playing) {
        this.pause();
      }
    } else if (prevProps.clipConfig.clipMode && !clipMode) {
      debug('[componentDidUpdate()] leaving clip mode');
      this.addKeyListeners();
    }

    if (clipMode) {
      if (prevProps.clipConfig.clipStart !== clipStart) {
        debug('[componentDidUpdate()] clipStart changed. Seek to ', clipStart * 1000);
        this.seek(clipStart * 1000);
      } else if (prevProps.clipConfig.clipEnd !== clipEnd) {
        debug('[componentDidUpdate()] clipEnd changed. Seek to ', clipEnd * 1000);
        this.seek(clipEnd * 1000);
      }
    }

    if (prevState.quality && prevState.quality !== this.state.quality) {
      const option = this.state.qualityOptions.find((o) => o.value === this.state.quality);

      if (option) {
        const videoSrc = ThumbnailUtil.createVideoPreviewUrl(this.props.selectedAsset, parseInt(option.label, 10));
        debug('[componentDidUpdate()] quality changed. videoSrc = ', videoSrc);
        this.setState({ videoSrc });
      }
    }

    if (prevState.isVideoUnavailable !== this.state.isVideoUnavailable) {
      this.maybeUpdateAudioPlayer();
    }

    if (this.props[SYNC_VIDEOS] && !prevProps[SYNC_VIDEOS]) {
      debug('[componentDidUpdate()] SYNC_VIDEOS = true. Switching to this._sharedController');
      this._sharedController.addListener('change', this.onControllerChange);
      this._privateController.removeListener('change', this.onControllerChange);
      this._privateController = null;
    } else if (!this.props[SYNC_VIDEOS] && prevProps[SYNC_VIDEOS]) {
      debug('[componentDidUpdate()] SYNC_VIDEOS = false. Switching to this._privateController');
      this._sharedController.removeListener('change', this.onControllerChange);
      if (!this._privateController) {
        this.createPrivateController();
      }
      this._privateController.addListener('change', this.onControllerChange);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedAsset !== this.props.selectedAsset) {
      this.setState({
        videoSrc: ThumbnailUtil.createVideoPreviewUrl(nextProps.selectedAsset)
      });
    }

    if (nextProps.quality !== this.props.quality) {
      this.setState({
        videoSrc: ThumbnailUtil.createVideoPreviewUrl(nextProps.selectedAsset, parseInt(nextProps.quality, 10)),
        quality: nextProps.quality
      });
    }

    // if (nextProps.comments !== this.props.comments) this.processComments(nextProps.comments);
  }

  componentWillUnmount() {
    const { videoSrc } = this.state;
    this.removeKeyListeners();
    _store.src = videoSrc;
    _store.currentTime = this.controller.currentTime;
    _store.volume = this.controller.volume;
    _store.muted = this.controller.muted;

    if (screenfull.enabled) {
      screenfull.off('change', this.onFullscreenToggle);
      toggleFullscreenClass();
    }

    if (this._audioPlayer) {
      this._audioPlayer.destroy();
    }

    this.controller.removeListener('change', this.onControllerChange);
    this.controller.setCurrentTime(0);
    this.controller.duration = 0;

    if (this._loadInfoJob && !this._loadInfoJob.done) {
      this._loadInfoJob.cancel();
    }

    // Storage.set('BACK_TO', null);
  }

  get controller(): VideoController {
    if (this.props[SYNC_VIDEOS]) {
      return this._sharedController;
    }

    if (!this._privateController) {
      this.createPrivateController();
    }

    return this._privateController;
  }

  isAudio = (repoItem = this.props.selectedAsset) => {
    return FileInfoUtil.isAudio(repoItem);
  };

  createPrivateController = () => {
    if (debug.enabled) {
      debug('[createPrivateController()] Created new private video controller.');
    }
    this._privateController = new VideoController(this._sharedController.state);
  };

  onControllerChange = async (prevState: VideoControllerState) => {
    try {
      if (this.props.waveplayer) {
        debug('[onControllerChange()] waveplayer');
        // TODO
      } else {
        if (!this._videoRef) {
          debug('[onControllerChange()] no _videoRef. return.');
          return;
        }

        if (prevState.currentTime !== this.controller.currentTime) {
          debug('[onControllerChange()] triggering debounced update of _videoRef.currentTime');
          this.setCurrentTime(this.controller.currentTime);
        }
        if (prevState.volume !== this.controller.volume) {
          debug('[onControllerChange()] updating _videoRef.volume to', this.controller.volume);
          this._videoRef.volume = this.controller.volume;
        }
        if (prevState.playbackRate !== this.controller.playbackRate) {
          debug('[onControllerChange()] updating _videoRef.playbackRate to ', this.controller.playbackRate);
          this._videoRef.playbackRate = this.controller.playbackRate;
        }
        if (prevState.muted !== this.controller.muted) {
          debug('[onControllerChange()] updating _videoRef.muted to ', this.controller.muted);
          this._videoRef.muted = this.controller.muted;
        }

        if (prevState.frameRate !== this.controller.frameRate) {
          debug('[onControllerChange()] updating _videoRef.frameRate to ', this.controller.frameRate);
          this._videoRef.frameRate = this.controller.frameRate;
        }

        if (this._canChangePlayState) {
          if (this._videoRef.paused && this.controller.playing) {
            debug('[onControllerChange()] playing video and setting this._canChangePlayState to false for 250ms.');
            this._canChangePlayState = false;
            setTimeout(() => (this._canChangePlayState = true), 250);
            await this._videoRef.play();
          } else if (!this._videoRef.paused && !this.controller.playing) {
            debug('[onControllerChange()] pausing video and setting this._canChangePlayState to false for 250ms.');
            this._canChangePlayState = false;
            setTimeout(() => (this._canChangePlayState = true), 250);
            await this._videoRef.pause();
          }
        } else {
          debug('[onControllerChange()] !this._canChangePlayState.');
        }
      }
    } catch (err) {
      debug('[onControllerChange()] error: ', err, err.message);
      console.error('Video cannot able to autoplay change your browser settings.');
      this.pause();
    } finally {
      if (this.refs.videoContainer) {
        this.forceUpdate();
      }
    }
  };

  _setCurrentTimeDebounceSettings = this.isAudio() ? undefined : { maxWait: 250 };

  setCurrentTime = _.debounce(
    (currentTime: number) => {
      debug('[setCurrentTime()] updating _videoRef.currentTime to ', currentTime);
      if (this._videoRef)
        this._videoRef.currentTime = currentTime;
    },
    100,
    this._setCurrentTimeDebounceSettings
  );

  fetchWaveform = () => {
    this.pause();
    const url = ThumbnailUtil.getAudioWaveFormUrl(this.props.selectedAsset);
    const image = new Image();
    image.onload = () => {
      this.setState({ didWaveformLoad: true });
      this.play();
    };

    image.src = url;
  };

  updateTextTracks = () => {
    if (!this._videoRef.textTracks) {
      return;
    }

    const { subtitle, subtitleOptions } = this.state;
    const index = _.findIndex(subtitleOptions, (o) => o.value === subtitle) - 1;
    [...this._videoRef.textTracks].forEach((track, i) => {
      track.mode = i === index ? 'showing' : 'hidden';
    });
  };

  updateAudioTracks = () => {
    const { audioTracks, activeAudioTrackIndex } = this.state;
    const src = audioTracks[activeAudioTrackIndex].src;
    this._audioPlayer.setSrc(src);
  };

  maybeUpdateAudioPlayer = () => {
    const { isVideoUnavailable, audioTracks, activeAudioTrackIndex } = this.state;
    if (isVideoUnavailable && this._audioPlayer) {
      this._audioPlayer.destroy();
      this._audioPlayer = null;
    } else if (!isVideoUnavailable && !this._audioPlayer && audioTracks.length) {
      const src = audioTracks[activeAudioTrackIndex].src;
      this._audioPlayer = new AudioPlayer(src, this._videoRef);
    }
  };

  onKeyDown = (e) => {
    if (this.props.blockKeyEvents) {
      debug('[onKeyDown()] blockKeyEvents. return.');
      return;
    }

    if (_.includes(['textarea', 'input'], e.target.nodeName.toLowerCase())) {
      debug('[onKeyDown()] target is an input box. return.');
      return;
    }

    // if (e.keyCode === 32 || e.keyCode === 80) {
    //   this.playPause();
    //   e.preventDefault();
    // }

    if (e.shiftKey) {
      if (e.keyCode === 39) this.onSeekForward();
      else if (e.keyCode === 37) this.onSeekBack();
    }
  };

  play() {
    this.controller.playing = true;
  }

  pause() {
    this.controller.playing = false;
  }

  playPause = () => {
    this.controller.playing = !this.controller.playing;
  };

  getMetadataTimeLineSeekChangeEvents(): MetadataTimelineSeekChangeEvents {
    return this._metadataTimelineSeekChangeEnvets;
  }

  /*   onSeekChange(e) {
      if (!this._seekStartX) {
        this._seekStartX = e.x;
        debug('[onSeekChange()] this._seekStartX: ', this._seekStartX);
      }
  
      if (this._playAfterSeek === null) {
        this._playAfterSeek = this.controller.playing;
        debug('[onSeekChange()] this._playAfterSeek: ', this._playAfterSeek);
      }
  
      if (Math.abs(e.x - this._seekStartX) > 10) {
        debug('[onSeekChange()] calling pause()');
        this.pause();
      }
  
      const newProgress = e.x * 1000;
      this.controller.setCurrentTime(newProgress / 1000, true);
      this.props.onSeekChange(newProgress);
    }
  
    onSeekChangeComplete = () => {
      debug('[onSeekChangeComplete()]');
      const playAfterSeek = this._playAfterSeek;
      this._playAfterSeek = false;
      this._seekStartX = 0;
      if (playAfterSeek) {
        if (!this._canChangePlayState) {
          debug('[onSeekChangeComplete()] _canChangePlayState=false, setting to true');
          this._canChangePlayState = true;
        }
        debug('[onSeekChangeComplete()] playing video');
        this.controller.playing = true;
      }
    }; */

  onSeekForward = async (e: MouseEvent | KeyboardEvent) => {
    if (this.metaDataRef && this.metaDataRef.nodeContainer.size >= 1) {
      this.metaDataRef.arrowKeyPress(e);
    } else {
      const fps = this.state.videoFrameRate || 24;
      this.pause();

      let step = 1 / fps;
      if (e && e.shiftKey) {
        step *= 10;
      }

      let newProgress = this.controller.currentTime + step;
      if (newProgress < 0) newProgress = 0;
      this.controller.setCurrentTime(newProgress, true);
      this.props.onSeekChange(newProgress * 1000);
    }
  };

  onSeekBack = (e: MouseEvent | KeyboardEvent) => {
    if (this.metaDataRef && this.metaDataRef.nodeContainer.size >= 1) {
      this.metaDataRef.arrowKeyPress(e);
    } else {
      const fps = this.state.videoFrameRate || 24;
      this.pause();

      let step = 1 / fps;
      if (e && e.shiftKey) {
        step *= 10;
      }

      let newProgress = this.controller.currentTime - step;
      if (newProgress < 0) newProgress = 0;
      this.controller.setCurrentTime(newProgress, true);
      this.props.onSeekChange(newProgress * 1000);
    }
  };

  onKeyDownJ = () => {
    const index = _.findIndex(playbackRateOptions, (o) => o.value === this.controller.playbackRate);
    if (index <= 0) {
      debug(`[onKeyDownJ()] cannot go slower than ${this.controller.playbackRate}. return.`);
      return;
    }

    const next = playbackRateOptions[index - 1];
    if (!next) {
      debug('[onKeyDownJ()] [warn] cannot change playback rate', { playbackRateOptions, index });
      return;
    }

    this.controller.playbackRate = next.value;
  };

  onKeyDownL = () => {
    const index = _.findIndex(playbackRateOptions, (o) => o.value === this.controller.playbackRate);
    if (index >= playbackRateOptions.length - 1) {
      debug(`[onKeyDownL()] cannot go faster than ${this.controller.playbackRate}. return.`);
      return;
    }

    const next = playbackRateOptions[index + 1];
    if (!next) {
      debug('[onKeyDownL()] [warn] cannot change playback rate', { playbackRateOptions, index });
      return;
    }

    this.controller.playbackRate = next.value;
  };

  addKeyListeners = () => {
    KeyboardShortcuts.add(new KeydownConfig('VIDEO', this.playPause, [KeyCode.SPACEBAR, KeyCode.K]));
    KeyboardShortcuts.add(new KeydownConfig('VIDEO', this.onKeyDownJ, [KeyCode.J]));
    KeyboardShortcuts.add(new KeydownConfig('VIDEO', this.onKeyDownL, [KeyCode.L]));
    KeyboardShortcuts.add(new KeydownConfig('VIDEO', this.onSeekBack, [KeyCode.LEFT]));
    KeyboardShortcuts.add(new KeydownConfig('VIDEO', this.onSeekForward, [KeyCode.RIGHT]));
    window.addEventListener('beforeunload', this.refreshBrowser); //catch beforeloading event
  };

  removeKeyListeners = () => {
    KeyboardShortcuts.remove('VIDEO');
    window.removeEventListener('beforeunload', this.refreshBrowser); //remove listner when componentWillUnmount
  };

  refreshBrowser() {
    //call then refresh event trigger.
    this.componentWillUnmount();
  }

  seek(milliseconds, comment) {
    //const seconds = Math.floor(milliseconds / 1000);
    this.setState({ progress: milliseconds });
    if (!this.props.waveplayer) {
      this.controller.setCurrentTime(milliseconds / 1000, true);
    }

    this.props.onSeekChange(milliseconds);
  }

  onFullscreenToggle = () => {
    toggleFullscreenClass();
    this.setState({ isFullscreen: screenfull.isFullscreen });
    this.props.onFullScreenChange(screenfull.isFullscreen);
    if (screenfull.isFullscreen) {
      this.props.addMouseListener();
    } else {
      this.props.removeMouseListener();
    }
  };

  onClickFullscreen() {
    if (this.props.onFullScreenToggle && !window.gs.isLinkUser) {
      this.props.onFullScreenToggle();
    } else {
      if (!screenfull.isFullscreen) {
        const { getFullScreenNode } = this.props;
        const node = getFullScreenNode ? getFullScreenNode() : findDOMNode(this.refs.videoContainer);
        screenfull.request(node);
      } else {
        screenfull.exit();
      }
    }
  }

  onProgress(e: Event) {
    const progress = this.getProgressMillis();

    const buffered = e.target.buffered;
    if (buffered && buffered.length) {
      let arr = [];
      for (let i = 0; i < buffered.length; i++) arr.push(i);
      const endTimes = arr.map((i) => buffered.end(i) * 1000);
      const bufferProgress = endTimes
        .sort((a, b) => (a > b ? 1 : -1))
        .reduce((val, endTime) => (val > progress ? val : endTime), 0);

      this.setState({ bufferProgress });
    }
    this.setVideoStartTimecodeMetadata();
    this.controller.setCurrentTime(progress / 1000);
    if (this.refs.seekBar) this.refs.seekBar.setState({ x: progress });
    if (this.props.onProgress) this.props.onProgress(progress);
  }

  onDuration() {
    const duration = this.getDurationMillis();
    Store.put(VIDEO_DURATION, duration / 1000);
    debug('[onDuration()] OnDuration: ', duration, 'Orignal: ', this._videoRef.duration);

    this.controller.duration = duration / 1000;
  }

  onError(e) {
    debug('[onError()] error: ', e.currentTarget.error);
    this.setState({ isVideoUnavailable: true });
  }

  setVolume = (volume = 0.7) => {
    if (this._audioPlayer) {
      this._audioPlayer.setVolume(volume);
    } else {
      this.controller.volume = volume;
    }
  };

  onVolume(event) {
    this.setVolume(event.x);
    this.props.onVolumeChange(event);
  }

  onMuted() {
    this.controller.muted = !this.controller.muted;
  }

  onLoad = () => {
    const { src, currentTime } = _store;
    if (CommentUtil.getActiveCommentThreadTime() != null) {
      let time = CommentUtil.getActiveCommentThreadTime();
      if (time > 1000) time - 1000;
      this.seek(time);
      CommentUtil.getActiveCommentThreadTime(null);
    } else if (this.state.videoSrc === src && currentTime) {
      this.seek(currentTime * 1000);
    }
    if (this.state.isVideoUnavailable) {
      this.setState({ isVideoUnavailable: false });
    }
  };

  onPlay(e) {
    debug('[onPlay()]');
    if (this.props.onPlay) {
      this.props.onPlay(e);
    }

    this.controller.playing = true;
  }

  onPause(e) {
    debug('[onPause()]');
    if (this.props.onPause) {
      this.props.onPause(e);
    }

    this.controller.playing = false;
  }

  onEnded = () => {
    this.pause();
    this.forceUpdate();
  };

  shapeDrawingStart() {
    this.pause();
    if (this.props.shapeDrawingStart) {
      this.props.shapeDrawingStart();
    }
  }

  shapeDrawingStop() {
    if (this.props.shapeDrawingStop) {
      this.props.shapeDrawingStop();
    }
  }

  getShapesForCurrentTime() {
    if (!this.props[SHOW_COMMENTS]) {
      return [];
    }

    if (this.controller.playing) {
      return [];
    }

    return getFilteredComments(this.props.comments).filter((comment: AnnotationThread) => {
      return (
        !!AnnotationUtil.getSpatialLocation(comment) &&
        CommentUtil.isInRange(AnnotationUtil.getVideOffsetInMilliseconds(comment), this.getProgressMillis(), 10)
      );
    });
  }
  changeVideoHeight = () => {
    this.forceUpdate();
  };
  getVideoControlsHeight = () => {
    if (!this.refs.videoContainer) {
      return 50;
    }

    const controlsNode = this.refs.videoContainer.querySelector('[name="VideoControls"]');
    const controlsHeight = controlsNode ? controlsNode.getBoundingClientRect().height : 50;

    const timelineNode = this.refs.videoContainer.querySelector('[name="MetadataTimeline"]');
    const timelineHeight =
      timelineNode && this.props[SHOW_METADATA_TIMELINE] ? timelineNode.getBoundingClientRect().height : 0;

    return controlsHeight + timelineHeight;
  };

  onScaleChange = (currentScale: number) => {
    this.setState({ currentScale });
  };

  drawDrawingCanvas() {
    if (!this.state.dataReady) return;

    if (this.props.waveplayer) {
      return null;
    }

    const shapes = this.getShapesForCurrentTime();
    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: `calc(100% - ${this.getVideoControlsHeight()}px)`
        }}>
        <DrawingCanvas
          ref="drawingCanvas"
          imageSrc={null}
          isUnavailable={this.state.isVideoUnavailable}
          width={this.state.videoPreviewResolutionX}
          height={this.state.videoPreviewResolutionY}
          shapeDrawingStart={() => this.shapeDrawingStart()}
          shapeDrawingStop={() => this.shapeDrawingStop()}
          onTextInputHide={this.props.onTextInputHide}
          onRender={this.props.onRender}
          onClickThroughShape={this.props.onClickThroughShape}
          shapes={shapes}
          addingShape={this.props.addingShape}
          attachments={this.props.attachments}
          onShapeCreated={(shape, callback) => this.onShapeCreated(shape, callback)}
          onShapeDeleted={this.props.onShapeDeleted}
          onShapeDrag={this.props.onShapeDrag}
          onShapeDragEnd={this.props.onShapeDragEnd}
          onScaleChange={this.onScaleChange}
        />
      </div>
    );
  }

  onCommentTimestampMakerClick = (time: number, comment: AnnotationThread) => {
    const id = comment.getThreadId();
    if (Store.get(ACTIVE_COMMENT_ID) === id) {
      Store.put(ACTIVE_COMMENT_ID, null);
      setTimeout(() => Store.put(ACTIVE_COMMENT_ID, id), 100);
    } else {
      Store.put(ACTIVE_COMMENT_ID, id);
    }
  };

  onGotoPrevComment = () => {
    if (this.props.onGotoPrevComment) this.props.onGotoPrevComment(this.getProgressMillis());
  };

  onGotoNextComment = () => {
    if (this.props.onGotoNextComment) this.props.onGotoNextComment(this.getProgressMillis());
  };

  onShapeCreated = (shape, callback) => {
    let tmpLoc = DrawingUtil.getTemporalLocation(shape, true);
    tmpLoc.setTimeOffset(this.getProgressMillis());
    this.props.onShapeCreated(shape, callback);
  };

  processComments = (comments) => {
    if (!comments) return;
    const commentMarkers = new Map();
    comments.forEach((c) => {
      const isTemporal = AnnotationUtil.getTemporalLocation(c);
      if (isTemporal) {
        const timePoint = AnnotationUtil.getVideOffsetInMilliseconds(c);
        let comments = commentMarkers.get(timePoint);
        if (!comments) comments = [];
        comments.push(c);
        commentMarkers.set(timePoint, comments);
      }
    });
    this.setState({ commentMarkersArray: Array.from(commentMarkers) });
  };

  getVideoThumbnail = (didWaveformLoad = false) => {
    // didWaveformLoad true / false in case of audio files
    const { selectedAsset } = this.props;
    const { isVideoUnavailable } = this.state;

    if (selectedAsset && this.isAudio() && didWaveformLoad) {
      return ThumbnailUtil.getAudioWaveFormUrl(selectedAsset); //.getBid(), selectedAsset.getFuid(), -1, selectedAsset.getName());
    }

    if (isVideoUnavailable) {
      return 'images/video_not_available.png';
    }

    return 'images/loading_video.png';
  };

  renderScreenToggleButton = () => {
    const { onFullScreenToggle, isExpandedMode, isCompareMode } = this.props;

    if (isCompareMode) return;

    if (window.gs.isLinkUser) {
      const isFullscreen = this.context.getTopBarVisibility() === Visibility.HIDDEN;
      return (
        <Div
          className="screen-toggle"
          onClick={this.onClickFullscreen}
          title={isFullscreen ? t('EXIT_FULL_SCREEN') : t('VIEW_FULL_SCREEN')}
          style={{ ...styles.iconArrowExpandColored }}>
          <i
            className={classNames('fa', { 'fa-arrows-alt': !isFullscreen, 'fa-compress': isFullscreen })}
            aria-hidden="true"
          />
        </Div>
      );
    }

    if (isExpandedMode) {
      return (
        <Div
          className="screen-toggle"
          onClick={this.onClickFullscreen}
          title={screenfull.isFullscreen ? t('EXIT_FULL_SCREEN') : t('VIEW_FULL_SCREEN')}
          style={{ ...styles.iconArrowExpandColored }}>
          <i
            className={classNames('fa', {
              'fa-arrows-alt': !screenfull.isFullscreen,
              'fa-compress': screenfull.isFullscreen
            })}
            aria-hidden="true"
          />
        </Div>
      );
    }

    if (onFullScreenToggle) {
      return (
        <Div
          className="screen-toggle"
          onClick={this.onClickFullscreen}
          title={t('VIEW_EXPANDED_SCREEN')}
          style={{ ...styles.iconArrowExpandColored }}>
          <i className="fa fa-expand" aria-hidden="true" />
        </Div>
      );
    }

    return (
      <div
        className="screen-toggle"
        onClick={screenfull.isFullscreen ? () => screenfull.exit() : this.onClickFullscreen}
        // title={t('VIEW_FULL_SCREEN')}
        title={screenfull.isFullscreen ? t('EXIT_FULL_SCREEN') : t('VIEW_FULL_SCREEN')}
        style={{ ...styles.iconArrowExpandColored }}>
        <i
          className={classNames('fa', {
            'fa-arrows-alt': !screenfull.isFullscreen,
            'fa-compress': screenfull.isFullscreen
          })}
          aria-hidden="true"
        />
      </div>
    );
  };

  toggleShowComments = () => {
    Store.put(SHOW_COMMENTS, !this.props[SHOW_COMMENTS]);
  };

  getSubtitleInfo = (previewInfo) => {
    let subtitles = previewInfo._subtitles || [];
    if (window.ARGS.cc) {
      try {
        subtitles = JSON.parse(decodeURIComponent(atob(window.ARGS.cc)));
      } catch (err) {
        // no op
      }
    }

    const subtitleOptions = subtitles.map((subtitle) => ({
      value: subtitle.id,
      label: subtitle.label
    }));

    if (subtitles.length) {
      subtitleOptions.unshift({ value: -1, label: 'No subtitles' });
    }

    return {
      subtitles,
      subtitleOptions,
      subtitle: subtitleOptions.length ? subtitleOptions[1].value : null
    };
  };

  getAudioTrackInfo = (previewInfo) => {
    let audioTracks = previewInfo._audioTracks || [];
    if (window.ARGS.audio) {
      try {
        audioTracks = JSON.parse(decodeURIComponent(atob(window.ARGS.audio)));
      } catch (err) {
        // no op
      }
    }

    const audioTrackOptions = audioTracks.map((audioTrack) => ({
      value: audioTrack.id,
      label: audioTrack.label
    }));

    if (audioTracks.length) {
      this._audioPlayer = new AudioPlayer(audioTracks[0].src, this._videoRef);
    }

    return {
      audioTracks,
      audioTrackOptions
    };
  };

  getQualityInfo = (previewInfo) => {
    let quality = 1;
    const qualityOptions = previewInfo.availableSizes.map((size, i) => ({
      value: i + 1,
      label: `${size}p`
    }));
    let x = `${previewInfo.defaultSize}p`;
    qualityOptions.forEach((qo) => {
      if (qo.label == x) quality = qo.value;
    });

    return {
      qualityOptions,
      quality: quality
    };
  };

  loadAssetInfo() {
    this._loadInfoJob = PreviewHelper.loadInfo(this.props.selectedAsset);
    this._loadInfoJob.promise.then(
      (previewInfo) => {
        if (!this.refs.videoContainer) {
          return;
        }
        const videoPreviewResolutionX =
          previewInfo._width && previewInfo._width != 'null' ? parseInt(previewInfo._width) : 1920;
        const videoPreviewResolutionY =
          previewInfo._height && previewInfo._height != 'null' ? parseInt(previewInfo._height) : 1080;
        const videoFrameRate = previewInfo._videoFrameRate;
        this.controller.frameRate = this.isAudio() && !videoFrameRate ? 24 : videoFrameRate;

        this.setState({
          videoPreviewResolutionX,
          videoPreviewResolutionY,
          videoFrameRate,
          dataReady: true,
          ...this.getQualityInfo(previewInfo),
          ...this.getSubtitleInfo(previewInfo),
          ...this.getAudioTrackInfo(previewInfo)
        });

        Store.put(ASSET_PREVIEW_INFO, previewInfo);
        Store.put(VIDEO_FRAME_RATE, videoFrameRate);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getProgressMillis() {
    const currentTime = this._videoRef ? this._videoRef.currentTime : this.controller.currentTime;
    return currentTime * 1000;
  }

  getDurationMillis() {
    const duration = this._videoRef ? this._videoRef.duration : this.controller.duration;
    return duration * 1000;
  }

  getVideoResolution() {
    return {
      width: this.state.videoPreviewResolutionX,
      height: this.state.videoPreviewResolutionY
    };
  }

  onClippingCancel = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      clipMode: false
    });
  };

  seekToCursor = (e: MouseEvent) => {
    const scale = this.getVideoContainerWidth() / this.controller.duration;
    const offset = e.target.getBoundingClientRect().left;
    const left = e.clientX - offset;
    const seconds = left / scale;
    this.seek(seconds * 1000);
  };

  onAudioMouseDown = (e: MouseEvent) => {
    if (this.props.clipConfig.clipMode) {
      return;
    }

    this._didAudioMouseDown = true;
    document.addEventListener('mouseup', this.onAudioMouseUp);
    this.seekToCursor(e);
  };

  onAudioMouseMove = (e: MouseEvent) => {
    if (!this._didAudioMouseDown) {
      return;
    }

    if (!this._isSeekingAudio) {
      this._isSeekingAudio = true;
      this._playAfterAudioSeek = this.controller.playing;
      this.pause();
    }

    this.seekToCursor(e);
  };

  onAudioMouseUp = () => {
    if (this._didAudioMouseDown) {
      debug('[onAudioMouseUp()] _didAudioMouseDown=true, setting to false');
      this._didAudioMouseDown = false;
      document.removeEventListener('mouseup', this.onAudioMouseUp);
    }

    if (this._isSeekingAudio) {
      debug('[onAudioMouseUp()] _isSeekingAudio=true, setting to false and checking _playAfterAudioSeek');
      this._isSeekingAudio = false;
      if (this._playAfterAudioSeek) {
        debug('[onAudioMouseUp()] _playAfterAudioSeek=true, calling play()');
        if (!this._canChangePlayState) {
          debug('[onAudioMouseUp()] _canChangePlayState=false, setting to true');
          this._canChangePlayState = true;
        }
        this.play();
      }
    }
  };

  onQualityChange = (quality: number) => {
    this.setState({ quality });
    this.props.onQualityChange(this, quality);
  };

  onSpeedChange = (playbackRate: number) => {
    this.controller.playbackRate = playbackRate;
    this.props.onSpeedChange(this, playbackRate);
  };

  onSubtitleChange = (subtitle: number) => {
    this.setState({ subtitle });
  };

  onAudioTrackChange = (value: number) => {
    const { audioTrackOptions } = this.state;
    this.setState({ activeAudioTrackIndex: _.findIndex(audioTrackOptions, (o) => o.value === value) });
  };

  onVideoRef = (node) => {
    this._videoRef = node;
  };

  onWaveplayerRef = (inst) => {
    this._videoRef = inst ? inst._component : null;
  };

  renderVideo = () => {
    const { selectedAsset, comments, waveplayer, renderWaveplayerComment, PERMISSIONS, isCompareMode } = this.props;

    const { videoSrc, isFullscreen, subtitles, autoPlay, didWaveformLoad } = this.state;
    const { muted, duration } = this.controller;
    if (waveplayer) {
      return (
        <WavePlayer
          ref={this.onWaveplayerRef}
          src={videoSrc}
          comments={comments}
          renderWaveplayerComment={renderWaveplayerComment}
          permissions={PERMISSIONS}
          is3DAsset={FileInfoUtil.is3DAsset(selectedAsset)}
          isCompareMode={isCompareMode}
        />
      );
    }

    const props = {
      ref: this.onVideoRef,
      src: videoSrc,
      autoPlay,
      draggable: false,
      muted,
      style: isFullscreen
        ? styles.videoPreviewFullscreen
        : {
          ...styles.videoPreview,
          height: `calc(100% - ${this.getVideoControlsHeight()}px)`
        },
      poster: duration && !this.state.isMediaLoading ? null : this.getVideoThumbnail(didWaveformLoad),
      onPlay: this.onPlay,
      onPause: this.onPause,
      onEnded: this.onEnded,
      onError: this.onError,
      onTimeUpdate: this.onProgress,
      onDurationChange: this.onDuration,
      onLoadedData: () => {
        this.setMediaLoading(false);
        this.onLoad();
      },
      onLoadStart: () => {
        this.setMediaLoading(true);
      }
    };

    const tracks = subtitles.map((subtitle, i) => (
      <track
        crossOrigin="use-credentials"
        key={subtitle.id}
        kind={subtitle.kind}
        src={ThumbnailUtil.getSubtitleUrl(subtitle.bid, subtitle.fuid, subtitle.rrn)}
        srcLang={subtitle.srcLang}
        label={subtitle.label}
        default={i === 0}
      />
    ));

    if (this.isAudio()) {
      const waveform = ThumbnailUtil.getAudioWaveFormUrl(selectedAsset);
      const height = props.style.height;
      //delete props.poster;
      delete props.style;
      delete props.autoPlay;
      //if (!didWaveformLoad) {
      //return <Spinner large />;
      //}
      return (
        <div
          className="waveform"
          style={{ width: '100%', height /*backgroundImage: `url('${waveform}')`*/ }}
          onMouseDown={this.onAudioMouseDown}
          onMouseMove={this.onAudioMouseMove}>
          {this.state.didWaveformLoad ? (
            <img src={waveform} style={{ width: '100%', height: '100%', position: 'absolute' }}></img>
          ) : null}
          <video crossOrigin="use-credentials" {...props}>
            {tracks}
          </video>
          {this.renderAudioLine()}
        </div>
      );
    }

    return (
      <video crossOrigin="use-credentials" {...props}>
        {tracks}
      </video>
    );
  };

  setMediaLoading = (isMediaLoading: boolean) => {
    this.setState({ isMediaLoading });
  }

  getVideoContainerWidth = () => {
    return this.refs.videoContainer ? this.refs.videoContainer.getBoundingClientRect().width : window.innerWidth - 370;
  };

  getVideoContainerHeight = () => {
    const dumbHeight = 'calc(100% - 80px)';
    if (!this.refs.videoContainer) {
      return dumbHeight;
    }

    const controlBar = this.refs.videoContainer.querySelector('.control-bar');
    if (!controlBar) {
      return dumbHeight;
    }

    const smartHeight =
      this.refs.videoContainer.getBoundingClientRect().height - controlBar.getBoundingClientRect().height;
    return smartHeight;
  };

  onTimelineResize = () => {
    this.forceUpdate();
  };

  setVideoStartTimecodeMetadata(): void {
    if (this.videoStartTimeCodeMetadata === undefined) {
      if (this.props.selectedAsset) {
        const startTimecodeMetadata: ?string = FileInfoUtil.getMetadata(this.props.selectedAsset, 'VDEO_Timecode');
        if (startTimecodeMetadata != null) {
          if (this.controller) {
            this.videoStartTimeCodeMetadata = smpteToMillis(startTimecodeMetadata, this.controller.frameRate);
            //$FlowFixMe
            this.controller.videoStartTimecode = this.videoStartTimeCodeMetadata;
            if (debug.enabled) {
              debug('[setVideoStartTimecodeMetadata()] %s', this.videoStartTimeCodeMetadata);
            }
          }
        } else {
          this.videoStartTimeCodeMetadata = 0;
          this.controller.videoStartTimecode = this.videoStartTimeCodeMetadata;
        }
      }
    }
  }

  renderAudioClipLines = () => {
    const clipConfig: ClipConfig = this.props.clipConfig;
    const { clipStart, clipEnd } = clipConfig;
    const { duration } = this.controller;
    const width = this.getVideoContainerWidth();
    const scale = width / duration;
    const style = {
      width: (clipEnd - clipStart) * scale
    };

    return (
      <div className="audio-clip-lines">
        {clipConfig.renderClipBody(scale, <div className="body" style={style} />)}
        {clipConfig.renderClipStart(
          scale,
          <div className="start">
            <div />
          </div>
        )}
        {clipConfig.renderClipEnd(
          width,
          scale,
          <div className="end">
            <div />
          </div>
        )}
      </div>
    );
  };

  renderAudioLine = () => {
    const { didWaveformLoad } = this.state;
    const { duration } = this.controller;
    if (!(didWaveformLoad && duration)) {
      return null;
    }

    const clipConfig: ClipConfig = this.props.clipConfig;
    if (clipConfig.clipMode) {
      return this.renderAudioClipLines();
    }

    const progress = this.getProgressMillis() / 1000;
    const style = {
      left: `${(progress / duration) * 100}%`
    };

    return <div className="audio-line" style={style} />;
  };

  renderControlBar = () => {
    const {
      enableComments,
      comments,
      onCommentButtonClick,
      renderAudioComment,
      renderDownloadButton,
      SHOW_COMMENTS: showComments,
      SHOW_METADATA_TIMELINE: showMetadataTimeline,
      waveplayer,
      callingFrom,
      compareViewRevisionIndex,
      isCompareMode
    } = this.props;

    const clipConfig: ClipConfig = this.props.clipConfig;

    const {
      activeAudioTrackIndex,
      audioTrackOptions,
      bufferProgress,
      isFullscreen,
      isVideoUnavailable,
      quality,
      qualityOptions,
      subtitle,
      subtitleOptions,
      videoFrameRate
    } = this.state;

    if (waveplayer) {
      return null;
    }

    const { canWriteComments } = this.props[PERMISSIONS];

    const props = {
      activeAudioTrackIndex,
      audioTrackOptions,
      bufferProgress,
      canWriteComments,
      clipConfig,
      comments,
      controller: this.controller,
      enableComments,
      isAudio: this.isAudio(),
      isFullscreen,
      mediaLoadFailed: isVideoUnavailable,
      onAudioTrackChange: this.onAudioTrackChange,
      onCommentButtonClick,
      onCommentTimestampMakerClick: this.onCommentTimestampMakerClick,
      onGotoNextComment: this.onGotoNextComment,
      onGotoPrevComment: this.onGotoPrevComment,
      onMuted: this.onMuted,
      onQualityChange: this.onQualityChange,
      onSeekBack: this.onSeekBack,
      onSeekChange: (data: any) => {
        this._metadataTimelineSeekChangeEnvets.onSeekChange(data.x);
      },
      onSeekChangeComplete: () => {
        this._metadataTimelineSeekChangeEnvets.onSeekChangeComplete();
      },
      onSeekForward: this.onSeekForward,
      onSpeedChange: this.onSpeedChange,
      onSubtitleChange: this.onSubtitleChange,
      onVolume: this.onVolume,
      playPause: this.playPause,
      quality,
      qualityOptions,
      renderAudioComment,
      renderDownloadButton,
      showComments,
      showMetadataTimeline,
      subtitleOptions,
      subtitle,
      toggleShowComments: this.toggleShowComments,
      videoFrameRate,
      compareViewRevisionIndex,
      callingFrom,
      isCompareMode,
      changeVideoHeight: this.changeVideoHeight
    };

    return <VideoControls {...props} />;
  };

  renderTimeline = () => {
    const { selectedAsset, clipConfig, assetAiData, waveplayer, callingFrom, isCompareMode, onDataTimeLineClick } = this.props;
    const { isFullscreen, isVideoUnavailable } = this.state;
    let isHide = false;
    if (isCompareMode) return;
    if (!callingFrom || callingFrom != 'collection') {
      if (!ViewUtil.isAssetTabActive()) {
        return null;
      }
    }

    if (isMobile()) {
      return null;
    }

    if (FileInfoUtil.is3DAsset(selectedAsset) || waveplayer) {
      return null;
    }

    if (isFullscreen || !this.props[SHOW_METADATA_TIMELINE]) {
      isHide = true;
    }

    const { videoFrameRate } = this.state;
    return (
      <MetadataTimeline
        metaDataReference={(ref) => (this.metaDataRef = ref)}
        asset={selectedAsset}
        isHide={isHide}
        widthOfCol={this.props.widthOfCol}
        clipConfig={clipConfig}
        controller={this.controller}
        videoDuration={Math.trunc(this.controller._duration) * 1000}
        videoFrameRate={videoFrameRate}
        onResize={this.onTimelineResize}
        onSeekChange={this.onSeekChange}
        onSeekChangeComplete={this.onSeekChangeComplete}
        metadataTimelineSeekChangeEvents={this._metadataTimelineSeekChangeEnvets}
        assetAiData={assetAiData}
        currentScale={this.state.currentScale}
        assetKeyframeMetadata={this.props.assetKeyframeMetadata}
        isRecording={this.state.isRecording}
        setAssetKeyframeAiData={this.props.setAssetKeyframeAiData}
        setOnLocateNodeSelection={this.props.setOnLocateNodeSelection}
        setDeleteTimelineRow={this.props.setDeleteTimelineRow}
        mediaLoadFailed={isVideoUnavailable}
        onDataTimeLineClick={onDataTimeLineClick}
      />
    );
  };

  render() {
    const { clipConfig } = this.props;
    const { didWaveformLoad, isVideoUnavailable } = this.state;
    return (
      <div
        ref="videoContainer"
        id="AssetImagePreview"
        name="AssetVideoPreview"
        className={classNames({
          video: !this.isAudio(),
          audio: this.isAudio() ? !(!didWaveformLoad || isVideoUnavailable) : false,
          'clip-mode': clipConfig.clipMode,
          'metadata-view': this.props[SHOW_METADATA_TIMELINE] && ViewUtil.isAssetTabActive()
        })}
        style={this.props.style}>
        {this.renderVideo()}
        {this.isAudio() ? null : this.drawDrawingCanvas()}
        {this.renderScreenToggleButton()}
        {this.renderTimeline()}
        {this.renderControlBar()}
      </div>
    );
  }
}

class MetadataTimelineSeekChangeEventsImpl implements MetadataTimelineSeekChangeEvents {
  assetVideoPreview: AssetVideoPreview;
  constructor(assetVideoPreview: AssetVideoPreview) {
    this.assetVideoPreview = assetVideoPreview;
    this.metaDataRef = React.createRef();
  }
  onSeekChange(time: number): void {
    if (!this.assetVideoPreview._seekStartX) {
      this.assetVideoPreview._seekStartX = time;
      debug('[onSeekChange()] this._seekStartX: ', this.assetVideoPreview._seekStartX);
    }

    if (this.assetVideoPreview._playAfterSeek === false) {
      this.assetVideoPreview._playAfterSeek = this.assetVideoPreview.controller.playing;
      debug('[onSeekChange()] this._playAfterSeek: ', this.assetVideoPreview._playAfterSeek);
    }

    if (Math.abs(time - this.assetVideoPreview._seekStartX) > 10) {
      debug('[onSeekChange()] calling pause()');
      this.assetVideoPreview.pause();
    }

    const newProgress = time * 1000;
    this.assetVideoPreview.controller.setCurrentTime(newProgress / 1000, true);
    this.assetVideoPreview.props.onSeekChange(newProgress);
  }
  onSeekChangeComplete(): void {
    debug('[onSeekChangeComplete()]');
    const playAfterSeek = this.assetVideoPreview._playAfterSeek;
    this.assetVideoPreview._playAfterSeek = false;
    this.assetVideoPreview._seekStartX = 0;
    if (playAfterSeek) {
      if (!this.assetVideoPreview._canChangePlayState) {
        debug('[onSeekChangeComplete()] _canChangePlayState=false, setting to true');
        this.assetVideoPreview._canChangePlayState = true;
      }
      debug('[onSeekChangeComplete()] playing video');
      this.assetVideoPreview.controller.playing = true;
    }
  }
}

const styles = {
  videoPreview: {
    display: 'block',
    width: '100%'
  },
  videoPreviewFullscreen: {
    display: 'block',
    width: '100%',
    height: '100%'
  },
  videoControlsDefault: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: '10',
    width: '100%'
  },
  videoControlsFullscreen: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 10
  },
  videoControlsSeekbar: {
    height: '10px',
    background: 'black'
  },
  controlButton: {
    marginRight: '10px',
    width: '14px',
    height: '14px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '100% 100%',
    cursor: 'pointer'
  },
  controlButtonText: {
    marginRight: '5px',
    fontSize: '12px',
    letterSpacing: '1px',
    fontWeight: 600,
    verticalAlign: 'top',
    height: '14px',
    cursor: 'pointer',
    color: '#EB6A5C',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  },
  quality: {},
  speed: {
    paddingLeft: '20px'
  },
  iconArrowExpandColored: {
    height: '40px',
    width: '40px',
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    zIndex: '11',
    fontSize: '20px',
    color: 'var(--primary-style-color)',
    textAlign: 'center',
    paddingTop: '8px'
  },
  formatLabelStyle: {
    height: '31px',
    width: '92px',
    borderRadius: '2px',
    backgroundColor: '#FFFFFF',
    padding: '8px',
    boxShadow: '#e0e0e0 0px 4px 9px 0px',
    visibility: 'hidden'
  },
  formatLabelText: {
    height: '15px',
    width: '71px',
    color: '#7A7A7A',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    lineHeight: '15px'
  },
  checkbox: {
    width: '15px',
    height: '15px',
    marginRight: '3px'
  },
  markerIndex: {
    position: 'absolute',
    top: 5,
    left: 5,
    borderRadius: '50%',
    height: '18px',
    width: '18px',
    color: '#FFF',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: '18px',
    backgroundColor: '#EB6A5C'
  },
  tooltipImageWrapper: {
    position: 'relative',
    paddingTop: '10px',
    paddingLeft: '10px'
  },
  tooltipTextWrapper: {
    flex: '1 1 150px',
    padding: '5px 15px 10px 10px'
  },
  tooltipTitle: {
    color: '#f6f6f6'
  },
  tooltipBody: {
    color: '#aaa',
    marginTop: '5px',
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipses',
    maxHeight: '60px'
  },
  tooltipMultipleComments: {
    color: '#f6f6f6',
    padding: '5px 10px'
  },
  initialLoading: {
    position: 'absolute',
    height: '200px',
    width: '400px',
    margin: '-100px 0 0 -200px',
    top: '50%',
    left: '50%',
    fontSize: '50px'
  }
};
